import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { trigger, state, style, transition, animate, query, stagger } from '@angular/animations';
import { CustomerService } from '../../services/customer.service';

@Component({
	selector: 'app-pending-auths',
	templateUrl: './pending-auths.component.html',
	styleUrls: ['./pending-auths.component.scss'],
	animations: [
		trigger('flipState', [
			state('active', style({ transform: 'rotate3d(0, 1, 0, 179deg)' })),
			state('inactive', style({ transform: 'rotateY(0)' })),
			transition('active => inactive', animate('500ms ease-out')),
			transition('inactive => active', animate('500ms ease-in')),
		]),
		trigger('grow', [
			transition(':enter', [
				style({ height: '0', width: '0' }),
				animate(200, style({ height: '*', width: '*' })),
				animate('200ms', style({ opacity: 1 })),
			]),
			transition(':leave', [
				animate(100, style({ height: 0, width: 0 })),
				animate('100ms', style({ opacity: 0 })),
			]),
		]),
	]
})
export class PendingAuthsComponent implements OnInit {
	@Output() viewData = new EventEmitter<any>();

	flip = 'inactive';
	preauthEnabled = false;
	items: any[] = [];
	expiringSoonCount = 0;
	isLoading = true;
	viewing: any = false;
	title = 'Pending Auths';

	constructor(private customerService: CustomerService) {}

	ngOnInit(): void {
		this.customerService.getPendingAuths().subscribe({
			next: (res: any) => {
				this.preauthEnabled = !!res.preauth_enabled;
				this.items = Array.isArray(res.items) ? res.items : [];
				this.expiringSoonCount = this.items.filter((i: any) => i.expiring_soon).length;
				this.isLoading = false;
			},
			error: () => {
				this.preauthEnabled = false;
				this.items = [];
				this.expiringSoonCount = 0;
				this.isLoading = false;
			}
		});
	}

	toggleFlip(open: boolean) {
		if (!open) {
			this.flip = 'inactive';
			this.viewData.emit(false);
			return;
		}
		this.flip = this.flip === 'active' ? 'inactive' : 'active';
		if (this.flip === 'active') {
			this.viewing = this.items;
			this.viewData.emit({ data: this.items, title: 'Pending Auths' });
		} else {
			this.viewData.emit(false);
		}
	}
}
